import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import { useParams } from "react-router-dom";

import './Individual.scss'
import { getIndividual } from '../../Context/Individual';
import Button from '../../Components/Button/Button'
import Page from '../../Components/Page/Page'
import Pages from '../../Context/Pages';
import Staff from '../../Components/Staff/Staff'

class Individual extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    const { params } = this.props;
    const indivdual = getIndividual(params.individual);

    return (
      <Page title='Individual' type='Custom'>
        <div className='individual-banner'>
          <Button page={Pages.Team}>
            ← Back
          </Button>
          <Staff
            name={indivdual.name}
            role={indivdual.role}
            email={indivdual.email}
            isInteractable={false}
          />
          <div className='individual-banner-corner' />
        </div>
        <div className='individual-blurb'>
          <p>{indivdual.paragraph1}</p>
          <br />
          <p>{indivdual.paragraph2}</p>
        </div>
      </Page>
    );
  }
}

Individual.contextType = GraingerAccountContext;

function ReturnIndividual(props) {
  return (
    <Individual
      {...props}
      params={useParams()}
    />
  );
}
export default ReturnIndividual;

// export default Individual;